import { render, staticRenderFns } from "./ComprobantesPage2.vue?vue&type=template&id=8715fab2"
import script from "./ComprobantesPage2.vue?vue&type=script&lang=js"
export * from "./ComprobantesPage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports